var _path, _path2, _path3, _circle, _circle2, _mask, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVulnerabilityIntelligence = function SvgVulnerabilityIntelligence(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49,
    height: 48,
    fill: "none",
    viewBox: "0 0 49 48"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    width: 28.266,
    height: 28.266,
    x: 2.27,
    y: 18.039
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.95px)",
      clipPath: "url(#vulnerability-intelligence_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.892,
    filter: "url(#vulnerability-intelligence_svg__b)",
    shapeRendering: "crispEdges"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vulnerability-intelligence_svg__c)",
    fillOpacity: 0.5,
    d: "M19.938 24.725a1.429 1.429 0 1 1 2.02 2.02l-9.09 9.091a1.429 1.429 0 1 1-2.021-2.02z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vulnerability-intelligence_svg__d)",
    fillOpacity: 0.25,
    d: "M19.938 24.725a1.429 1.429 0 1 1 2.02 2.02l-9.09 9.091a1.429 1.429 0 1 1-2.021-2.02z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    strokeWidth: 0.714,
    d: "M21.706 24.977a1.07 1.07 0 0 1 0 1.515l-9.092 9.092a1.072 1.072 0 0 1-1.515-1.515l9.092-9.092a1.07 1.07 0 0 1 1.515 0Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 28.756,
    height: 28.756,
    x: -0.71,
    y: 20.406
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.95px)",
      clipPath: "url(#vulnerability-intelligence_svg__e)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.892,
    filter: "url(#vulnerability-intelligence_svg__f)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vulnerability-intelligence_svg__g)",
    d: "M14.418 28.102a2.857 2.857 0 1 1 4.041 4.04l-5.54 5.54a2.857 2.857 0 1 1-4.041-4.04z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    strokeWidth: 0.714,
    d: "M18.207 28.355a2.5 2.5 0 0 1 0 3.535l-5.541 5.54a2.5 2.5 0 0 1-3.536-3.535l5.541-5.54a2.5 2.5 0 0 1 3.535 0Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 39.183,
    height: 39.183,
    x: 9.071,
    y: 0.271
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.93px)",
      clipPath: "url(#vulnerability-intelligence_svg__h)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.862,
    filter: "url(#vulnerability-intelligence_svg__i)",
    shapeRendering: "crispEdges"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.662,
    cy: 18,
    r: 12.143,
    fill: "url(#vulnerability-intelligence_svg__j)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 28.662,
    cy: 18,
    r: 12.143,
    fill: "url(#vulnerability-intelligence_svg__k)",
    style: {
      mixBlendMode: "screen"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.662,
    cy: 18,
    r: 11.786,
    stroke: "#fff",
    strokeOpacity: 0.25,
    strokeWidth: 0.714
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 29.42,
    height: 30.893,
    x: 13.952,
    y: 4.444
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.95px)",
      clipPath: "url(#vulnerability-intelligence_svg__l)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.892,
    filter: "url(#vulnerability-intelligence_svg__m)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "vulnerability-intelligence_svg__r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vulnerability-intelligence_svg__n"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vulnerability-intelligence_svg__o)",
    fillOpacity: 0.2,
    d: "M27.416 10.68c.595-.332.893-.499 1.044-.53.2-.041.204-.041.404 0 .151.031.449.197 1.044.53 1.015.567 2.505 1.147 4.371 1.343.525.055.787.083.971.19a1 1 0 0 1 .383.398c.1.189.114.395.14.809.24 3.644-.81 9.583-6.51 12.282-.196.092-.294.139-.425.162-.102.018-.25.018-.352 0-.131-.023-.23-.07-.425-.162-5.7-2.699-6.75-8.638-6.51-12.282.027-.414.04-.62.14-.809a1 1 0 0 1 .383-.398c.184-.107.447-.135.97-.19 1.867-.196 3.357-.776 4.372-1.343",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vulnerability-intelligence_svg__p)",
    d: "M27.416 10.68c.595-.332.893-.499 1.044-.53.2-.041.204-.041.404 0 .151.031.449.197 1.044.53 1.015.567 2.505 1.147 4.371 1.343.525.055.787.083.971.19a1 1 0 0 1 .383.398c.1.189.114.395.14.809.24 3.644-.81 9.583-6.51 12.282-.196.092-.294.139-.425.162-.102.018-.25.018-.352 0-.131-.023-.23-.07-.425-.162-5.7-2.699-6.75-8.638-6.51-12.282.027-.414.04-.62.14-.809a1 1 0 0 1 .383-.398c.184-.107.447-.135.97-.19 1.867-.196 3.357-.776 4.372-1.343",
    shapeRendering: "crispEdges",
    style: {
      mixBlendMode: "screen"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    d: "m21.69 12.611.632.334zm.384-.398.358.618zm7.19 13.489.305.645zm-.426.162-.126-.703zm-.777-.162-.306.645zm.425.162.126-.703zm6.764-13.651.358-.618zm.383.398-.631.334zm-5.725-1.931-.348.624zm-1.044-.53-.144.7zm-.404 0-.145-.7zm1.448.53-.348.624c1.09.609 2.673 1.222 4.645 1.43l.075-.71.074-.711c-1.76-.185-3.158-.732-4.097-1.257zm5.866 2.74-.713.047c.232 3.525-.797 9.077-6.103 11.589l.305.646.306.645c6.094-2.885 7.165-9.212 6.918-12.974zM28.06 25.702l.306-.646c-5.307-2.512-6.336-8.064-6.104-11.59l-.713-.046-.712-.047c-.248 3.762.824 10.09 6.917 12.974zm-5.016-13.679.074.71c1.972-.207 3.555-.82 4.645-1.43l-.348-.623-.348-.623c-.94.524-2.337 1.07-4.098 1.256zM21.55 13.42l.713.047c.015-.219.023-.339.037-.429.011-.075.021-.09.022-.093l-.631-.334-.632-.333c-.186.353-.198.739-.221 1.095zm1.495-1.397-.075-.71c-.252.026-.477.05-.662.082a1.8 1.8 0 0 0-.592.2l.358.618.358.618c-.013.007.004-.008.124-.029.124-.022.291-.04.563-.068zm-1.354.588.631.334a.3.3 0 0 1 .11-.114l-.358-.618-.358-.618a1.7 1.7 0 0 0-.657.683zm7.572 13.09-.305-.645c-.105.05-.156.073-.196.09a.2.2 0 0 1-.05.015l.126.703.126.703c.242-.043.43-.137.605-.22zm-1.202 0-.306.646c.176.083.363.177.605.22l.126-.703.126-.703a.2.2 0 0 1-.05-.016 4 4 0 0 1-.195-.089zm.777.163-.126-.703-.012.001h-.075l-.013-.001-.126.703-.126.703c.186.034.418.034.604 0zm5.441-13.84-.074.71c.272.028.44.046.563.068.12.021.137.036.124.029l.358-.618.358-.618a1.8 1.8 0 0 0-.592-.2c-.184-.032-.41-.056-.662-.082zm1.495 1.396.712-.047c-.023-.357-.034-.742-.22-1.095l-.633.333-.631.334c.001.002.011.018.023.093.013.09.022.21.036.429zm-.524-1.207-.358.618a.3.3 0 0 1 .11.114l.631-.334.632-.333a1.7 1.7 0 0 0-.657-.684zm-5.342-1.533.349-.623q-.44-.248-.708-.389a2.2 2.2 0 0 0-.54-.217l-.145.7-.144.699c-.036-.008-.008-.007.17.086.156.08.368.199.67.368zm-2.492 0 .348.624c.302-.169.514-.287.67-.368.178-.093.206-.094.17-.086l-.144-.7-.145-.7a2.2 2.2 0 0 0-.54.218q-.269.141-.707.389zm1.448-.53.145-.7c-.075-.015-.207-.045-.347-.045s-.272.03-.347.046l.145.7.144.699.09-.018c.009-.002-.006.001-.032.001-.025 0-.04-.003-.032-.001l.03.005.06.013z",
    mask: "url(#vulnerability-intelligence_svg__r)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vulnerability-intelligence_svg__c",
    x1: 17.028,
    x2: 10.847,
    y1: 29.655,
    y2: 35.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vulnerability-intelligence_svg__g",
    x1: 18.444,
    x2: 2.558,
    y1: 28.369,
    y2: 44.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vulnerability-intelligence_svg__j",
    x1: 28.662,
    x2: 28.662,
    y1: 16.634,
    y2: 30.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vulnerability-intelligence_svg__o",
    x1: 28.662,
    x2: 28.662,
    y1: 16.836,
    y2: 25.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vulnerability-intelligence_svg__a",
    transform: "translate(-2.27 -18.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.938 24.725a1.429 1.429 0 1 1 2.02 2.02l-9.09 9.091a1.429 1.429 0 1 1-2.021-2.02z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vulnerability-intelligence_svg__e",
    transform: "translate(.71 -20.406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.418 28.102a2.857 2.857 0 1 1 4.041 4.04l-5.54 5.54a2.857 2.857 0 1 1-4.041-4.04z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vulnerability-intelligence_svg__h",
    transform: "translate(-9.07 -.27)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.662,
    cy: 18,
    r: 12.143
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vulnerability-intelligence_svg__l",
    transform: "translate(-13.952 -4.444)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vulnerability-intelligence_svg__n"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vulnerability-intelligence_svg__b",
    width: 28.266,
    height: 28.266,
    x: 2.27,
    y: 18.039,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.783
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4553_2355"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4553_2355",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vulnerability-intelligence_svg__f",
    width: 28.756,
    height: 28.756,
    x: -0.71,
    y: 20.406,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.783
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4553_2355"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4553_2355",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vulnerability-intelligence_svg__i",
    width: 39.183,
    height: 39.183,
    x: 9.071,
    y: 0.271,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.862
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.724
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4553_2355"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4553_2355",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vulnerability-intelligence_svg__m",
    width: 29.42,
    height: 30.893,
    x: 13.952,
    y: 4.444,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.783
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4553_2355"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4553_2355",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "vulnerability-intelligence_svg__d",
    width: 16,
    height: 2.909,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vulnerability-intelligence_svg__q",
    transform: "scale(.01563 .00284)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "vulnerability-intelligence_svg__k",
    width: 1.853,
    height: 1.853,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vulnerability-intelligence_svg__q",
    transform: "scale(.00181)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "vulnerability-intelligence_svg__p",
    width: 3.2,
    height: 2.901,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vulnerability-intelligence_svg__q",
    transform: "scale(.00313 .00283)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "vulnerability-intelligence_svg__n",
    d: "M27.416 10.68c.595-.332.893-.499 1.044-.53.2-.041.204-.041.404 0 .151.031.449.197 1.044.53 1.015.567 2.505 1.147 4.371 1.343.525.055.787.083.971.19a1 1 0 0 1 .383.398c.1.189.114.395.14.809.24 3.644-.81 9.583-6.51 12.282-.196.092-.294.139-.425.162-.102.018-.25.018-.352 0-.131-.023-.23-.07-.425-.162-5.7-2.699-6.75-8.638-6.51-12.282.027-.414.04-.62.14-.809a1 1 0 0 1 .383-.398c.184-.107.447-.135.97-.19 1.867-.196 3.357-.776 4.372-1.343"
  }))));
};
export default SvgVulnerabilityIntelligence;